import { reactive, computed } from 'vue';

type SubpageEntry = {
  id: string;
  title: string;
  component: any;
  props?: Record<string, any>;
};

type TabKey = string; // e.g., '/mobile/eval/evaluation-results'

const state = reactive<{ tabStacks: Record<TabKey, SubpageEntry[]> }>({
  tabStacks: {},
});

export function useMobileSubpageStore() {
  const getStack = (tabKey: TabKey) => {
    if (!state.tabStacks[tabKey]) state.tabStacks[tabKey] = [];
    return state.tabStacks[tabKey];
  };

  const pushSubpage = (tabKey: TabKey, entry: SubpageEntry) => {
    const stack = getStack(tabKey);
    // 동일 id가 연속으로 중복되지 않도록 처리
    const last = stack[stack.length - 1];
    if (last && last.id === entry.id) return;
    stack.push(entry);
  };

  const popSubpage = (tabKey: TabKey) => {
    const stack = getStack(tabKey);
    if (stack.length > 0) stack.pop();
  };

  const clearSubpages = (tabKey: TabKey) => {
    state.tabStacks[tabKey] = [];
  };

  const peekSubpage = (tabKey: TabKey) => {
    const stack = getStack(tabKey);
    return stack[stack.length - 1] || null;
  };

  const stackLength = (tabKey: TabKey) => computed(() => getStack(tabKey).length);

  return {
    state,
    getStack,
    pushSubpage,
    popSubpage,
    clearSubpages,
    peekSubpage,
    stackLength,
  };
}
